import { pick } from 'lodash';
import orderFilters from 'App/babel/filterConfigs/Order';
import agreementFilters from 'App/babel/filterConfigs/Agreement';
import activityFilters from 'App/babel/filterConfigs/Activity';
import appointmentFilters from 'App/babel/filterConfigs/Appointment';
import useCategoryConfigs from '../useCategoryConfigs';
import { FilterConfig } from 'App/babel/filterConfigs/FilterConfig';

const useFiltersWithCategories = (filters: { [key: string]: FilterConfig }) => {
	const accountCategories = useCategoryConfigs(
		'account',
		'Account',
		{
			field: 'client.category.id',
			parent: 'default.account',
			entity: undefined
		},
		'default.accountCategories'
	);

	return {
		...filters,
		...accountCategories
	};
};

export const useOrderFilters = () => useFiltersWithCategories(orderFilters());

/**
 * Curated subset of the Order filters for the company-card sales/orders list.
 * Scoped to a single company, so account-level filters (categories, managers,
 * connections) are intentionally left out. `ListSearch` powers the free-text
 * search box (surfaced via ListView's `quickSearchFilter`). The Probability
 * preset is excluded so nothing fights the card's hardcoded `probability=100`
 * (Stage only narrows among the won stages, so it's safe to include).
 */
export const useSalesCardOrderFilters = (): { [key: string]: FilterConfig } =>
	pick(orderFilters(), ['Date', 'User', 'Stage', 'Contact', 'ValueRange', 'OrderRowProduct', 'ListSearch']);

export const useAgreementFilters = () => useFiltersWithCategories(agreementFilters());

export const useActivityFilters = () => useFiltersWithCategories(activityFilters());

export const useAppointmentFilters = () => useFiltersWithCategories(appointmentFilters());
